import { useLocation } from "react-router-dom";

import { Link, Stack, Text } from "@seneca/senekit";

import { linkToSignIn } from "features/sign-up/links";

export default function LogInLink({
  loginLink = linkToSignIn()
}: {
  loginLink?: string;
}) {
  const location = useLocation();
  return (
    <Stack space="medium" align="center">
      <Text size="small" tone="neutral" emphasis="medium">
        Already have an account?
      </Text>
      <Link to={{ ...location, pathname: loginLink }} size="small">
        Log in
      </Link>
    </Stack>
  );
}
